import router from "./index"
import NProgress from 'nprogress'


// 路由跳转前
router.beforeEach((to, from, next) => {
  NProgress.start();
  if (to.meta.title) {
      document.title = to.meta.title
  }
  const isBackend = to.meta.isBackend;  // 判断是前端页面还是管理页面
  if (to.matched.some(record => record.meta.mustAuth)) {
      const token = localStorage.getItem('token')
      if (isBackend) {
          if (token) {
              next()
          } else {
             NProgress.done();
              next({path: '/admin/login'})
          }
      }
      else{
          if (token) {
              next()
          } else {
                NProgress.done();
              next({path: '/login'})
          }
      }
  }
  else{
      next()
  }
})

// 路由跳转后
router.afterEach(transition => {
  NProgress.done();
})

export default router


// WEBPACK FOOTER //
// ./src/router/router.js